import { render, staticRenderFns } from "./TermsCollaborations.vue?vue&type=template&id=d3746676"
import script from "./TermsCollaborations.vue?vue&type=script&lang=js"
export * from "./TermsCollaborations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports